import React, { useState } from 'react';

function FAQ() {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const faqs = [
    {
      id: 'what-is-this',
      question: 'What is Movie Identifier?',
      answer: 'Movie Identifier helps you find a movie title from a short video clip or a link to Shorts/Reels. Upload a small clip or paste a link, and we will try to identify the film.'
    },
    {
      id: 'how-to-use',
      question: 'How do I use it?',
      answer: 'Choose Upload File to select a short video or screenshot, or switch to Paste Link to submit a public Shorts/Reels link. Then click Search and wait for the result.'
    },
    {
      id: 'supported-formats',
      question: 'Which formats are supported?',
      answer: 'Common video formats (like MP4, MOV) and images are supported. For links, use public URLs to YouTube Shorts or similar platforms.'
    },
    {
      id: 'length',
      question: 'What clip length works best?',
      answer: 'Clips between 5–20 seconds usually work best. Shorter clips can still work if the frame is distinctive.'
    },
    // {
    //   id: 'privacy',
    //   question: 'What about privacy?',
    //   answer: 'We process your upload solely for identification. Avoid uploading sensitive content. For any concern, contact letmeplzdoit@gmail.com.'
    // },
    {
      id: 'not-found',
      question: 'It says “Not found”. What should I do?',
      answer: 'Try a different segment of the video, improve quality if possible, or include audio when available. Distinctive scenes generally produce better matches.'
    }
  ];

  return (
    <div className="content-wrapper">
      <div className="main-content">
        <div className="faq-container" style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 className="blog-heading">FAQ</h2>
          <div className="faq-list" style={{ marginTop: '1.5rem' }}>
            {faqs.map(item => (
              <div key={item.id} className="faq-item" style={{
                background: '#fff',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.06)',
                marginBottom: '1rem',
                overflow: 'hidden'
              }}>
                <button
                  onClick={() => toggleItem(item.id)}
                  className="faq-question"
                  style={{
                    width: '100%',
                    textAlign: 'left',
                    padding: '1rem 1.25rem',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    color: '#333',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <span>{item.question}</span>
                  <span style={{ transform: openItems[item.id] ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.2s ease' }}>▼</span>
                </button>
                <div
                  className="faq-answer"
                  style={{
                    maxHeight: openItems[item.id] ? '300px' : '0',
                    transition: 'max-height 0.25s ease',
                    overflow: 'hidden',
                    background: '#f8f9fa'
                  }}
                >
                  <div style={{ padding: openItems[item.id] ? '1rem 1.25rem' : '0 1.25rem' }}>
                    <p style={{ color: '#5f6368' }}>{item.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;



